// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f760bd4b","74":"198c4800","484":"35e4eea7","551":"9c933560","760":"10b56e1e","828":"d9977c64","842":"eef346f6","909":"f5b47ff4","950":"946f83e0"}[chunkId] + ".chunk.js";
};